import { Component, OnInit } from '@angular/core';
import $ from "jquery";
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent  implements OnInit {
  title = 'workout-angular';

  customOptions: OwlOptions = {
    loop: true,
      margin: 0,
      nav: true,
      items: 1,
      dots: false,
      animateOut: 'fadeOut',
      animateIn: 'fadeIn',
      navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
      smartSpeed: 1200,
      autoHeight: false,
      autoplay: false
  }

  ngOnInit(): void {
    // this.renderSlider();
  }

  renderSlider() {
    // $(".hs-slider").owlCarousel({
    //     loop: true,
    //     margin: 0,
    //     nav: true,
    //     items: 1,
    //     dots: false,
    //     animateOut: 'fadeOut',
    //     animateIn: 'fadeIn',
    //     navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
    //     smartSpeed: 1200,
    //     autoHeight: false,
    //     autoplay: false
    // });
  }

}
